import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dialog-header',
  styleUrls: ['./dialog-header.component.scss'],
  templateUrl: './dialog-header.component.html',
})
export class DialogHeaderComponent {
  @Input() title: string;
  @Input() subtitle: string;
}
